import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";


interface PreguntaState {
    status: string;
    error: string;
    preguntasList: any[],
    pregunta: {
        idPregunta: number | null;
        idEvaluacion: number | null;
        orden: number | null;
        idTipoPregunta: number | null;
        tipoPregunta: string | null;
        punteo: number | null;
        titulo: string | null;
        descripcion: string | null;
        urlReferencia: string | null;
        minimo: number | null;
        maximo: number | null;
        respuestaCorrecta: number | null;
        respuestasList: RespuestasList[],
    }
}

interface RespuestasList {
    idRespuesta: number | null;
    idPregunta: number | null;
    descripcion: string | null;
    valido: number | null;
}

const initialState: PreguntaState = {
    status: "idle",
    error: "",
    preguntasList: [],
    pregunta: {
        idPregunta: null,
        idEvaluacion: null,
        orden: null,
        idTipoPregunta: null,
        tipoPregunta: null,
        punteo: null,
        titulo: null,
        descripcion: null,
        urlReferencia: null,
        minimo: null,
        maximo: null,
        respuestaCorrecta: null,
        respuestasList: []
    }
}

export const fetchPregunta = createAsyncThunk('fetchPregunta', async ({ idEvaluacion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 94;
    const { result, message, data } = await getData({ idsp, idEvaluacion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const createModifyPregunta = createAsyncThunk('createModifyPregunta', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const preguntaNew = selectPregunta(state);
    const preguntaAttributes = { ...preguntaNew };
    const idsp = preguntaAttributes.idPregunta ? 93 : 92;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...preguntaAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    return rejectWithValue(message);
});

export const deletePregunta = createAsyncThunk('deletePregunta', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const preguntaNew = selectPregunta(state);
    const preguntaAttributes = { ...preguntaNew }
    const idPregunta = preguntaAttributes.idPregunta;
    const idsp = 95;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idPregunta }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisibleSecondary(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    return rejectWithValue(message);
});

export const preguntaSlice = createSlice({
    name: 'pregunta',
    initialState,
    reducers: {
        setPregunta: (state, action) => {
            state.pregunta = !action.payload ? initialState.pregunta : action.payload;
        },
        setPreguntasList: (state, action) => {
            state.preguntasList = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchPregunta.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPregunta.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.preguntasList = data ? data : [];

            })
            .addCase(fetchPregunta.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})
export const selectPregunta = (state: RootState) => state.pregunta.pregunta;
export const selectPreguntasList = (state: RootState) => state.pregunta.preguntasList;

export const { setPregunta, setPreguntasList } = preguntaSlice.actions;

export default preguntaSlice.reducer;